import { render, staticRenderFns } from "./RepairIndex.vue?vue&type=template&id=c6a72f52"
import script from "./RepairIndex.vue?vue&type=script&lang=js"
export * from "./RepairIndex.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports